export default class AdminConfigurationService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity() {
		return this.apiService.callGet('adminConfiguration')
	}

	getVersion() {
		return this.apiService.callGet('getVersion');
	}

	updateEntity(params) {
		return this.apiService.callPut('adminConfiguration', params)
	}

}



// WEBPACK FOOTER //
// ./src/service/AdminConfigurationService.js